export const shadows = {
	low: '0px 2px 2px rgba(0, 0, 0, 0.05), 0px 3px 19px rgba(58, 41, 62, 0.06)',
	elevated: '0px 4px 13px rgba(95, 95, 95, 0.07), 0px 18px 26px rgba(123, 123, 123, 0.12)',
	elevatedSelected: '0px 4px 13px rgba(90, 95, 39, 0.07), 0px 18px 26px rgba(123, 117, 42, 0.12)',
	floating:
		'0px 148px 59px rgba(0, 0, 0, 0.01), 0px 83px 50px rgba(0, 0, 0, 0.05), 0px 37px 37px rgba(0, 0, 0, 0.09), 0px 9px 20px rgba(0, 0, 0, 0.1)',
};
